export const LANGUAGES = {
  en: 'English',
  es: 'Español',
  pt: 'Português',
} as const;

export type LanguageLocale = keyof typeof LANGUAGES;
